module.exports = __webpack_public_path__ + "img/stop.daf3f86e.png";